import {
  faCircleCheck,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons'
import { clsx } from 'clsx'

import { Icon } from 'Components/Icon/Icon'

import type { DeviceHealthProgressCircleProps } from './DeviceHealthProgressCircle.types'

const SIZE = 112
const CENTER = SIZE / 2
const RADIUS = 48
const STROKE_WIDTH = 10
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

export const DeviceHealthProgressCircle = (
  props: DeviceHealthProgressCircleProps,
) => {
  const { value, label, isWarning, className } = props

  const clampedValue = Math.min(100, Math.max(0, value))
  const offset = CIRCUMFERENCE * (1 - clampedValue / 100)

  return (
    <div
      className={clsx(
        'DeviceHealthProgressCircle',
        !isWarning && 'DeviceHealthProgressCircle-healthy',
        className,
      )}
    >
      <svg
        height={SIZE}
        role="img"
        viewBox={`0 0 ${SIZE} ${SIZE}`}
        width={SIZE}
      >
        <circle
          className="DeviceHealthProgressCircle-track"
          cx={CENTER}
          cy={CENTER}
          fill="none"
          r={RADIUS}
          strokeWidth={STROKE_WIDTH}
        />

        <circle
          className="DeviceHealthProgressCircle-value"
          cx={CENTER}
          cy={CENTER}
          fill="none"
          r={RADIUS}
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={offset}
          strokeLinecap="round"
          strokeWidth={STROKE_WIDTH}
          transform={`rotate(-90 ${CENTER} ${CENTER})`}
        />

        <text
          className="DeviceHealthProgressCircle-percentage"
          dominantBaseline="central"
          textAnchor="middle"
          x={CENTER}
          y={CENTER}
        >
          {clampedValue}
        </text>
      </svg>

      <div className="DeviceHealthProgressCircle-label">
        <Icon
          className="DeviceHealthProgressCircle-label-icon"
          icon={isWarning ? faTriangleExclamation : faCircleCheck}
          size={20}
        />

        {label}
      </div>
    </div>
  )
}
